var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.componentName
    ? _c(
        "b-tab",
        { attrs: { title: _vm.methodName } },
        [
          _c(
            "no-ssr-loader",
            [
              _c(_vm.componentName, {
                tag: "component",
                on: {
                  "selected-card": _vm.selectedCard,
                  error: (err) => _vm.$emit(err),
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }